<template>
	<div class="main-containter" v-title data-title="和华利盛">
		<FHeader :checkId="23"></FHeader>
		<!-- <FOtherBanner :name1="'关于我们'" :name2="'About Us'"></FOtherBanner> -->
		<!-- <FTitle></FTitle> -->
		<article style="height: 100%;">
			<div style="padding-left: 18%;padding-top: 20px;">
				<el-breadcrumb separator="/">
				<el-breadcrumb-item :to="{ path: '/' }" style="cursor: pointer;">首页</el-breadcrumb-item>
				<el-breadcrumb-item  style="cursor: default;">关于我们</el-breadcrumb-item>
				<el-breadcrumb-item :to="{ path: '/redConstruction' }" style="cursor: pointer;">红色建设</el-breadcrumb-item>
				<el-breadcrumb-item style="color:black;cursor: default;">内容详情</el-breadcrumb-item>
			</el-breadcrumb>
			</div>
			<div style="width: 64%;padding: 30px 18%;margin-top:50px;">
				<div style="text-align: center;padding-bottom: 20px;border-bottom: 1px solid #D7D7D7;">
					<div style="font-size: 26px;color: black;margin-bottom: 20px;">{{item.title}}</div>
					<div style="padding-top: 5px;font-size: 14px;color: #AAAAAA;margin-bottom: 50px;">发布时间：{{item.publish.substring(0,10)}}</div>
					<v-md-preview  style="text-align:left;" :text="item.content" ref="preview"  id="preview"></v-md-preview>
				</div>
				<div style="margin-top: 20px;height: 40px;">
					<div class="upAndDown" style="float: left;font-size: 14px;width: 50%;overflow: hidden;text-overflow: ellipsis;white-space: normal;height: 20px;" @click="toUp()">上一篇：{{up.title}}</div>
					<div class="upAndDown" style="float: right;font-size: 14px;width: 50%;text-align: right;overflow: hidden;text-overflow: ellipsis;white-space: normal;height: 20px;" @click="toNext()">下一篇：{{next.title}}</div>
				</div>
			</div>
		</article>
		<Footer></Footer>
	</div>
</template>

<script>
	import FHeader from "../../components/f/FHeaderDetail.vue"
	import { defineComponent, onMounted, reactive, ref, toRefs } from 'vue';
	// import FOtherBanner from "../../components/f/FOtherBanner.vue"
	import Footer from "../../components/f/Footer.vue"

	import {queryNext} from "@/api/aboutUs";
	export default {
		name: "Index",
		
		components: {
			FHeader,
			// FOtherBanner,
			Footer
		},
		data() {
			return {
				item: {},
				up: {},
				next: {},
				pageNo:1,
				total:0,
				index:0,
				tableLength:0,
				id:0
			}
		},//decodeURIComponent(
		created() {
			this.id = this.$route.query.id
			this.queryNext()
			// this.item = JSON.parse(this.$route.query.item)
			// this.up = JSON.parse(this.$route.query.up)
			// this.next = JSON.parse(this.$route.query.next)
			// this.pageNo = this.$route.query.pageNo
			// this.total = this.$route.query.total
			// this.index = this.$route.query.index
			// this.tableLength = this.$route.query.tableLength
			// console.log(this.pageNo)
			// console.log(this.total)
			// console.log(this.index)
			// console.log(this.up)
			// console.log(this.next)
		},
		mounted() {
			this.id = this.$route.query.id
			this.queryNext()
		},
		activated() {
			this.id = this.$route.query.id
			this.queryNext()
		},
		watch: {
		},
		methods: {
			queryNext(){
				let param = {}
				param.id = this.id
				queryNext(param).then(data => {
						this.item = data.data.item
						this.up = data.data.up
						this.next = data.data.next
					}).catch(error => {
						this.$message.error(error)
				})
			},
			async toNext(){
				let that = this
				if(this.next.id != 0){
					this.id = this.next.id
					this.queryNext()
					// let up = {}
					// let next = {}
					// let pageNo = this.pageNo
					// let index = parseInt(this.index) +1
					// if((parseInt(this.index) + 1) == this.tableLength){
					// 	pageNo = pageNo+1
					// 	index = 0
					// 	let size = (((this.pageNo)-1)*9)+(parseInt(this.index)+1)
					// 	if(size == this.total){
					// 		next.title = '无'
					// 		next.id = 0
					// 	}else{
					// 		let param = {
					// 			title: '',
					// 			channelId: null,
					// 			page: (parseInt(this.pageNo)+1),
					// 			pageSize: 9,
					// 		}
					// 		await query(param).then(data => {
					// 			next = data.data.list[0]
					// 		}).catch(error => {
					// 			this.$message.error(error)
					// 		})
					// 	}
					// }else{
					// 	let param = {
					// 			title: '',
					// 			channelId: null,
					// 			page: this.pageNo,
					// 			pageSize: 9,
					// 		}
					// 		await query(param).then(data => {
					// 			next = data.data.list[(parseInt(this.index)+2)]
					// 		}).catch(error => {
					// 			this.$message.error(error)
					// 		})
					// }
					// console.log(index)
					// console.log(this.item.id)
					// console.log(this.next.id)
					// console.log(next.id)
					
					// that.up = that.item
					// that.item = that.next
					// that.next = next
					// that.pageNo = pageNo
					// that.index = index
					//encodeURIComponent(
					// this.$router.push(
					// 	{
					// 		path:'/redConstructionDetail',
					// 		query:{
					// 			up:JSON.stringify(this.item),
					// 			item:JSON.stringify(this.next),
					// 			next:JSON.stringify(next),
					// 			total:this.total,
					// 			pageNo:pageNo,
					// 			index:index
					// 		}
					// 	}
					// );
				}else{
					this.$message.error("无下一篇。")
				}
			},
			async toUp(){
				let that = this
				if(this.up.id != 0){
					this.id = this.up.id
					this.queryNext()
					// let index = parseInt(this.index) -1
					// let up = {}
					// let next = {}
					// let pageNo = this.pageNo
					// if(this.pageNo == 1 && (parseInt(this.index)-1) == 0){
					// 	up.title = '无'
					// 	up.id = 0
					// }else if((parseInt(this.index)-1) == 0){
					// 	pageNo = pageNo-1
					// 	index = 8
					// 	let param = {
					// 		title: '',
					// 		channelId: null,
					// 		page: (parseInt(this.pageNo)-1),
					// 		pageSize: 9,
					// 	}
					// 	await query(param).then(data => {
					// 		up = data.data.list[data.data.list.length-1]
					// 	}).catch(error => {
					// 		this.$message.error(error)
					// 	})
					// }else{
					// 	let param = {
					// 		title: '',
					// 		channelId: null,
					// 		page: parseInt(this.pageNo),
					// 		pageSize: 9,
					// 	}
					// 	await query(param).then(data => {
					// 		up = data.data.list[parseInt(this.index)-1]
					// 	}).catch(error => {
					// 		this.$message.error(error)
					// 	})
					// }
					// console.log(up.id)
					// console.log(this.up.id)
					// console.log(this.item.id)
					// console.log(index)
					// that.up = up
					// that.item = that.up
					// that.next = that.item
					// that.pageNo = pageNo
					// that.index = index
					// encodeURIComponent(
					// this.$router.push(
					// 	{
					// 		path:'/redConstructionDetail',
					// 		query:{
					// 			up:JSON.stringify(up),
					// 			item:JSON.stringify(this.up),
					// 			next:JSON.stringify(this.item),
					// 			total:this.total,
					// 			pageNo:pageNo,
					// 			index:index
					// 		}
					// 	}
					// );
				}else{
					this.$message.error("无上一篇。")
				}
			}
		}
	}
</script>
<style lang="scss" scoped="scoped">
	.upAndDown:hover{
		color: #98273A;
	}
	.upAndDown{
		cursor: pointer;
	}

	span /deep/ .el-breadcrumb__inner{
		font-weight: 400 !important;
		color: #606266 !important;
		cursor: default !important;
	}
	span /deep/ .el-breadcrumb__inner.is-link{
		font-weight: 400 !important;
		color: #606266 !important;
		cursor: pointer !important;
	}
div /deep/ .el-pagination.is-background .btn-next:disabled{
    margin: 0 5px;
    background-color: white !important;
    min-width: 30px;
    border-radius: 2px !important;
    font-weight: 400 !important;
    border: 1px solid #D9D9D9 !important;
		color: #C3C3C7 !important;
}
div /deep/ .el-pagination.is-background .btn-prev:disabled{
    margin: 0 5px;
    background-color: white !important;
    min-width: 30px;
    border-radius: 2px !important;
    font-weight: 400 !important;
    border: 1px solid #D9D9D9 !important;
		color: #C3C3C7 !important;
}
div /deep/ .el-pagination.is-background .btn-prev{
    /*进行修改未选中背景和字体*/
    margin: 0 5px;
    background-color: white !important;
    color: #606266 !important;
    min-width: 30px;
    border-radius: 2px !important;
    font-weight: 400 !important;
    border: 1px solid #D9D9D9 !important;
}
div /deep/ .el-pagination.is-background .btn-next{
    /*进行修改未选中背景和字体*/
    margin: 0 5px;
    background-color: white !important;
    color: #606266 !important;
    min-width: 30px;
    border-radius: 2px !important;
    font-weight: 400 !important;
    border: 1px solid #D9D9D9 !important;
}
div /deep/ .el-pagination.is-background .el-pager li{
    /*进行修改未选中背景和字体*/
    margin: 0 5px;
    background-color: white !important;
    color: #606266 !important;
    min-width: 30px;
    border-radius: 2px !important;
    font-weight: 400 !important;
    border: 1px solid #D9D9D9 !important;
}

div /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
  /*进行修改选中项背景和字体*/
	background-color: #98273A !important;
  color:white !important;
  border-radius: 2px !important;
  font-weight: 400 !important;
  border: 1px solid #98273A !important;
}

div /deep/ .el-pagination.is-background .el-pager li:hover{
   color: #98273A !important;/*hover时候的文字颜色*/
 }
div /deep/ .el-pager li.active{
   color:#98273A !important;/*仅设置active时的文字颜色*/
 }
div /deep/ .el-pagination{
	text-align: center;
}
</style>
